require('../../../shared/css/flex.css');
require('../../../shared/css/navbar.css');
require('../../../shared/css/main.css');
require('../css/index.css');
require('../css/fournisseurs.css');
require('../css/marche.css');
require('../css/adherents.css');


var fournisseurs = require('../js/fournisseurs');
var adhesion = require('../js/adhesion');
var magasins = require('../js/magasins');
var smoothScroll = require('../../../shared/js/smoothScroll');
var contact = require('../../../shared/js/sendContactForm');
var navbar = require('../../../shared/js/navbar');

var datamagasins = require('../json/magasins.json');

$(document).ready(function($){
  document.body.scrollTop = 0;
  navbar();
  fournisseurs();
  adhesion();
  // smoothScroll();
  magasins(datamagasins)
  getSize();
  contact();
  contactadresse()
});

function getSize() {
  var myWidth = 0, myHeight = 0;
  if( typeof( window.innerWidth ) == 'number' ) {
    //Non-IE
    myWidth = window.innerWidth;
    myHeight = window.innerHeight;
  } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
    //IE 6+ in 'standards compliant mode'
    myWidth = document.documentElement.clientWidth;
    myHeight = document.documentElement.clientHeight;
  } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
    //IE 4 compatible
    myWidth = document.body.clientWidth;
    myHeight = document.body.clientHeight;
  }
  $("#transition").css("height",myHeight/1.5)
}

function contactadresse(){
  var name = "gvabio";
  var at = "@";
  var domain = "noos.fr"
  $("#contactemail").append(name+at+domain);
  $("#contactemail").attr('href','mailto:'+name+at+domain);
}



//////////////////
// WEBPACK FOOTER
// ./app/pages/index/js/index.js
// module id = 5
// module chunks = 0